import React from 'react';
import { useLogin } from '@/modules/register/hooks';
import Button, { IButtonProps } from '@/components/Button';

export interface ILoginButtonLinkProps extends IButtonProps {}

export const LoginButtonLink = (props: ILoginButtonLinkProps) => {
  const { handleUtmLogin } = useLogin();

  return (
    // login in auth page should always point to account login url
    <Button
      analytics={['AUTH_LOGIN']}
      id="auth_submit_login"
      isFullWidth
      onClick={handleUtmLogin}
      {...props}
    >
      ورود
    </Button>
  );
};
